import {Editor} from "@tiptap/core";
import ICONS from "../../assets/ICONS";
import {Transaction} from "prosemirror-state";
import {DceJsx} from "dce-jsx";
import {ToolbarItem} from "../ToolbarItem";

export default class LinkButton extends ToolbarItem {

    private editor:Editor;

    private options: HTMLElement;

    private optionsUrl: HTMLInputElement;
    private optionsTarget: HTMLSelectElement;
    private optionsBtnAccept: HTMLButtonElement;
    private optionsBtnRemove: HTMLButtonElement;

    constructor() {
        super();
    }

    mount(editor: Editor): void {
        this.editor = editor;
    }

    public click(e: any): void {
        if(this.options.contains(e.target as HTMLElement)){

        }else{

            if(!this.root.classList.contains('disabled')) {
                if(!this.root.classList.contains('opened')) {
                    this.preOpen();
                    this.root.classList.add('opened');
                }else{
                    this.root.classList.remove('opened');
                }
            }

        }

    }

    public preOpen(){
        let active = this.editor.isActive('link');

        if(active){
            let a = this.editor.getAttributes('link');
            this.optionsUrl.value = a.href;
            this.optionsTarget.value = a.target;
        }else{
            this.optionsUrl.value = '';
            this.optionsTarget.value = '';
        }
    }

    public consumeTransaction(editor: Editor, transaction: Transaction): void{
        if(this.isActive(editor)){
            this.root.classList.add('active');
        }else{
            this.root.classList.remove('active');
        }

        if(this.root.classList.contains('opened')){
            this.root.classList.remove('opened');
        }
    }

    public setLink(): void {

        let url = this.optionsUrl.value;
        let target = this.optionsTarget.value;

        if(url){
            //aktualizacja linka
            (this.editor.chain().focus().extendMarkRange('link') as any)
                .setLink({ href: this.optionsUrl.value , target: target}).run();
        }else{
            //usuniecie linka
            (this.editor.chain().focus().extendMarkRange('link') as any).unsetLink().run()
        }

    }

    public removeLink(): void {

        if(this.editor.isActive('link')){
            (this.editor.chain().focus().extendMarkRange('link') as any).unsetLink().run()
        }

    }

    public isActive(editor:Editor): boolean {
        return this.editor.isActive('link');
    }


    bindByRef(ref: string, elem: HTMLElement) {
        if(ref == 'options'){
            this.options = elem;
        }

        switch (ref){
            case 'o-url':
                this.optionsUrl = elem as HTMLInputElement;
                break;

            case 'o-target':
                this.optionsTarget = elem as HTMLSelectElement;
                break;

            case 'o-btn-accept':
                this.optionsBtnAccept = elem as HTMLButtonElement;
                break;

            case 'o-btn-remove':
                this.optionsBtnRemove = elem as HTMLButtonElement;
                break;
        }

    }

    render(): JSX.Element {
        return (
            <button type="button" onClick={(e) => this.click(e)} className={"btn dropdown"}>
                <i ref={"current-icon"} dangerouslySetInnerHTML={{__html: ICONS.link}}></i>

                <div className={"options link-options"} ref={"options"}>
                    <input type={"text"} ref={"o-url"} placeholder={"https://..."}/>

                    <div className={"link-options--row"}>
                        <div className={"link-options--row-lbl"}>Otwórz link w</div>
                        <select ref={"o-target"}>
                            <option value={""}>Aktualnym oknie</option>
                            <option value={"_blank"}>Nowy oknie</option>
                        </select>
                    </div>

                    <button type="button" ref={"o-btn-accept"} onClick={() => this.setLink()} className={"gray"}>Wstaw link</button>
                    <button type="button" ref={"o-btn-remove"} onClick={() => this.removeLink()}>Usuń link</button>
                </div>
            </button>
        );
    }
}